import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '@core/services/dialog.service';

/**
 * @description диалоговое информационное алерт окно, используется в связке с DialogService,
 * настраиваемые параметры передаются через MatDialogRef/MAT_DIALOG_DATA
 * при подтверждении эмитит true в dialogRef
 * @param title заголовок окна, по умолчанию "Подтвердите действие"
 * @param content дополнительная инфо более мелким шрифтом
 * @param confirmBtn текст на кнопке подтверждения, по умолчанию "ОК"
 * @param isError красит текст content (дополнительная инфо) в красный цвет
 */

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.less']
})
export class AlertComponent implements OnInit {
    title = 'common.confirm_action';
    content = '';
    confirmBtn = 'common.ok';
    isError = false;

    constructor(
        private dialogRef: MatDialogRef<AlertComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) private data: DialogData
    ) {}

    ngOnInit() {
        if (this.data) {
            this.title = this.data?.title ?? 'common.confirm_action';
            this.content = this.data?.content ?? '';
            this.confirmBtn = this.data?.confirmBtn ?? 'common.ok';
            this.isError = !!this.data?.isError;
        }
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}
